import AssetsCheckBoxList from './AssetsCheckBoxList'

export default AssetsCheckBoxList
